import { loginKeyBase } from 'alto-react-base-auth/lib/settings'

export canteenKeyBase  = 'canteen.'
export menuKey         = canteenKeyBase + 'menu'
export confirmationKey = menuKey + '.confirmation'
export lockingKey      = menuKey + '.locking'
export alergensKey     = menuKey + '.alergens'

export GLOBAL    = 'global'
export PER_GROUP = 'per_group'

export menuSetting = (settings) ->
  general      = settings.safeFindBy(key: menuKey)?.value         or {}
  confirmation = settings.safeFindBy(key: confirmationKey)?.value or {}
  locking      = settings.safeFindBy(key: lockingKey)?.value      or {}
  alergens     = settings.safeFindBy(key: alergensKey)?.value     or {}

  enabled:         general.enabled            ? true
  numberOfDays:    general.number_of_days     ? 10
  refreshPeriod:   general.refresh_period     ? 60 # in seconds
  showDaysWOMeals: general.show_days_wo_meals ? true

  confirmation:
    style: confirmation.style ? PER_GROUP

  locking:
    skipEmptyDays: locking.skip_empty_days ? true

  alergens:
    linkUrl: alergens.link_url

export terminalLoginKey = loginKeyBase + 'terminal_login'

export terminalLoginSetting = (settings) ->
  setting = settings.safeFindBy(key: terminalLoginKey)?.value or {}

  enabled: setting.enabled ? false
